import { useEffect, useState } from "react";
import axios from "axios";
import config from "../../../config";

const useJunctionList = () => {
  const [junctions, setJunctions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    axios
      .get(`${config.FLYOVER_RCM_API_URL}/junctions`, {
        headers: { "X-API-Key": config.FLYOVER_RCM_API_TOKEN },
      })
      .then((res) => {
        if (isMounted) setJunctions(res.data?.data ?? []);
      })
      .catch((err) => console.error("useJunctionList: fetch failed", err))
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  return { junctions, loading };
};

export default useJunctionList;
